import './App.css';
import { useState, useEffect } from "react";
import { BrowserRouter , Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import StartScreen from "./components/StartScreen";
import Quiz from "./components/Quiz";
import Result from "./components/Result";
import {startGame} from './service/index.js'
import setWxShare from './utiles/wxShare'



// 页面切换动画配置
const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.95,
  },
  in: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  out: {
    opacity: 0,
    scale: 1.05,
    transition: {
      duration: 0.2,
      ease: "easeIn",
    },
  },
};

const AnimatedRoutes = ()=>{
  const location = useLocation();
  const [step, setStep] = useState("start");
  const [totalScore,setTotalScore] = useState(0);
  const [question,setQuestion] = useState({})

  useEffect(()=>{
    getStartGame();
    if (isWeiXin()) {
      setWxShare({
          title: "AI or Not – Find the real Song paintings",
          desc: "Song Dynasty art connoisseurs, assemble! Test your discernment in AI or Not – decode paintings to uncover authentic classical masterpieces! Can you spot the brush of history? Play now!",
          site_link: 'https://news.cgtn.com/event/2025/ai-or-not/song-painting/index.html',
          img_url: 'https://news.cgtn.com/event/2025/ai-or-not/song-painting/poster.png',
          success: () => {
              console.log('Share success!')
          },
          cancel: () => {
              console.log('Share cancel!')
          },
      })
    }
    const handleBeforeUnload = (event) => {
      // event.preventDefault();
      if(localStorage.getItem('aiOrNot')){
        localStorage.removeItem('aiOrNot')
      }
    };
 
    window.addEventListener('beforeunload', handleBeforeUnload);
 
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  },[])
  // wxShare
  function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
  }
  const getStartGame= async()=>{
    // console.log('88888')
    const aiOrNot = (localStorage.getItem('aiOrNot') && JSON.parse(localStorage.getItem('aiOrNot'))) || '';
    const res = await startGame({
      method: 'POST',
      body: JSON.stringify({
          session_id:aiOrNot.session_id || '',
      }),
      headers:{
          "content-type":'application/json'
      },
    }).then(res=>res)
    const data = await res.json()
    if(res.status== 200){
      localStorage.setItem('aiOrNot',JSON.stringify({session_id:data.session_id,game_number:data.game_number}))
      setQuestion(data.question)
    }
  }

  const handleStart = () => {
    if(question.id){
      setStep("quiz");
    }
  };
  const playAgain = async()=>{
    setStep("start");
    setQuestion({});
    await getStartGame()
    setTotalScore(0)
  }
  const handleQuiz = (totalScore)=>{
    setTotalScore(totalScore)
  }
  return       <AnimatePresence mode="wait">
  <div className='app_wraper'>
    {step === "start" ? (
      <motion.div
        key="start"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        <StartScreen onStart={handleStart} />
      </motion.div>
    ) : null}
    {step === "quiz" ? (
      <motion.div
        key="quiz"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
          <Quiz totalScore={totalScore} onQuizChange={handleQuiz} question={question} onChangeStep={(value)=>setStep(value)}/>
      </motion.div>
    ) : null}
    {step === "result" ? (
      <motion.div
        key="result"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        <Result totalScore={totalScore} playAgain={playAgain}/>
      </motion.div>
    ) : null}
  </div>
</AnimatePresence>
}
function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
